import {
    ADD_ITEM_TO_CART_FAILURE,
    ADD_ITEM_TO_CART_REQUEST,
    ADD_ITEM_TO_CART_SUCCESS,
    GET_CART_FAILURE,
    GET_CART_REQUEST,
    GET_CART_SUCCESS,
    REMOVE_CART_ITEM_FAILURE,
    REMOVE_CART_ITEM_REQUEST,
    REMOVE_CART_ITEM_SUCCESS,
    UPDATE_CART_ITEM_FAILURE,
    UPDATE_CART_ITEM_REQUEST,
    UPDATE_CART_ITEM_SUCCESS,
    APPLY_COINS_CART_REQUEST,
    APPLY_COINS_CART_FAILURE,
    APPLY_COUPON_CART_REQUEST,
    APPLY_COUPON_CART_FAILURE,
    FIND_CART_BY_ID_REQUEST,
    FIND_CART_BY_ID_SUCCESS,
    FIND_CART_BY_ID_FAILURE,
    APPLY_COUPON_CART_SUCCESS,
    SET_BUY_NOW_CHECKOUT,
    CLEAR_BUY_NOW_CHECKOUT
} from "./ActionType";

const readBuyNowState = () => {
    try {
        const isBuyNowCheckout = sessionStorage.getItem("buyNowActive") === "1";
        const bagItemCount = isBuyNowCheckout
            ? JSON.parse(sessionStorage.getItem("buyNowCartSnapshot") || "[]").length
            : 0;
        return { isBuyNowCheckout, bagItemCount };
    } catch (error) {
        return { isBuyNowCheckout: false, bagItemCount: 0 };
    }
};

const initialState = {
    cart: null,
    loading: false,
    addLoading: false,
    error: null,
    cartItems: [],
    ...readBuyNowState(),
}

export const cartReducer = (state = initialState, action) => {
    switch (action.type) {

        case ADD_ITEM_TO_CART_REQUEST:
            return { ...state, addLoading: true, error: null };

        case ADD_ITEM_TO_CART_SUCCESS:
            return { ...state, addCartItem: action.payload, addLoading: false, error: null };

        case ADD_ITEM_TO_CART_FAILURE:
            return { ...state, addLoading: false, error: action.payload };

        case GET_CART_REQUEST:
        case FIND_CART_BY_ID_REQUEST:
            return { ...state, loading: true, error: null };

        case GET_CART_SUCCESS:
        case FIND_CART_BY_ID_SUCCESS:
            return { ...state, cartItems: action.payload.cartItems, cart: action.payload, loading: false, error: null };

        case GET_CART_FAILURE:
        case FIND_CART_BY_ID_FAILURE:
            return { ...state, loading: false, error: action.payload };

        case REMOVE_CART_ITEM_REQUEST:
        case UPDATE_CART_ITEM_REQUEST:
        case APPLY_COINS_CART_REQUEST:
        case APPLY_COUPON_CART_REQUEST:
            return { ...state, loading: true, error: null };

        // ✅ REMOVE FIX — immediately update state.cartItems
        case REMOVE_CART_ITEM_SUCCESS:
            return {
                ...state,
                cartItems: state.cartItems.filter(item => item.id !== action.payload),
                loading: false,
                error: null,
            };

        // ✅ UPDATE FIX — modify item inside cartItems
        case UPDATE_CART_ITEM_SUCCESS:
            return {
                ...state,
                cartItems: state.cartItems.map(item =>
                    item.id === action.payload.id ? { ...item, ...action.payload } : item
                ),
                loading: false,
                error: null
            };

        case APPLY_COUPON_CART_SUCCESS:
            return {
                ...state,
                cartItems: action.payload.cartItems, cart: action.payload,
                loading: false,
                error: null
            };

        case REMOVE_CART_ITEM_FAILURE:
        case UPDATE_CART_ITEM_FAILURE:
        case APPLY_COINS_CART_FAILURE:
        case APPLY_COUPON_CART_FAILURE:
            return { ...state, loading: false, error: action.payload };

        case SET_BUY_NOW_CHECKOUT:
            return { ...state, isBuyNowCheckout: true, bagItemCount: action.payload || 0 };

        case CLEAR_BUY_NOW_CHECKOUT:
            return { ...state, isBuyNowCheckout: false, bagItemCount: 0 };

        default:
            return state;
    }
}
